import { Check, X } from 'lucide-react';
export const FeatureComparisonTable = () => {
  const features = [{
    name: 'Menu Planning & Recipes',
    starter: true,
    premium: true,
    enterprise: true
  }, {
    name: 'Sysco CSV Order Generation',
    starter: true,
    premium: true,
    enterprise: true
  }, {
    name: 'Real-Time Inventory Tracking',
    starter: false,
    premium: true,
    enterprise: true
  }, {
    name: 'Advanced Cost & Waste Reports',
    starter: false,
    premium: true,
    enterprise: true
  }, {
    name: 'Multi-Location Management',
    starter: false,
    premium: false,
    enterprise: true
  }, {
    name: 'Staff Seats Included',
    starter: '4 (1 Admin + 3 Staff)',
    premium: '10',
    enterprise: 'Unlimited'
  }, {
    name: 'Support Level',
    starter: 'Email',
    premium: 'Priority Email',
    enterprise: 'Dedicated Rep'
  }, {
    name: 'Custom Integrations (EDI/SFTP)',
    starter: false,
    premium: 'Optional Add-On',
    enterprise: true
  }];
  return <section id="comparison-table" className="py-20 px-4 sm:px-6 lg:px-8 bg-background">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-foreground mb-4">Compare Plans</h2>
          <p className="text-lg text-muted-foreground">
            Find the perfect fit for your operation
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse bg-card rounded-xl shadow-sm overflow-hidden">
            <thead>
              <tr className="bg-gradient-to-r from-deep-teal to-midnight-green">
                <th className="py-6 px-6 text-left text-ivory font-semibold text-lg">Feature</th>
                <th className="py-6 px-6 text-center text-ivory font-semibold text-lg border-l border-copper/20">Foundation</th>
                <th className="py-6 px-6 text-center text-ivory font-semibold text-lg border-l border-copper/20 bg-copper/10">
                  <div className="flex flex-col items-center">
                    <span>Professional</span>
                    <span className="text-xs font-normal text-copper mt-1">Most Popular</span>
                  </div>
                </th>
                <th className="py-6 px-6 text-center text-ivory font-semibold text-lg border-l border-copper/20">Enterprise</th>
              </tr>
            </thead>
            <tbody>
              {features.map((feature, index) => <tr key={feature.name} className={`transition-colors hover:bg-muted/50 ${index % 2 === 0 ? 'bg-card' : 'bg-muted/20'}`}>
                  <td className="py-4 px-6 text-foreground font-medium border-t border-border">
                    {feature.name}
                  </td>
                  <td className="py-4 px-6 text-center border-t border-l border-border">
                    {typeof feature.starter === 'boolean' ? feature.starter ? <Check className="h-5 w-5 text-green-600 mx-auto" /> : <X className="h-5 w-5 text-muted-foreground/40 mx-auto" /> : <span className="text-foreground">{feature.starter}</span>}
                  </td>
                  <td className="py-4 px-6 text-center border-t border-l border-border bg-copper/5">
                    {typeof feature.premium === 'boolean' ? feature.premium ? <Check className="h-5 w-5 text-green-600 mx-auto" /> : <X className="h-5 w-5 text-muted-foreground/40 mx-auto" /> : <span className="text-foreground font-medium">{feature.premium}</span>}
                  </td>
                  <td className="py-4 px-6 text-center border-t border-l border-border">
                    {typeof feature.enterprise === 'boolean' ? feature.enterprise ? <Check className="h-5 w-5 text-green-600 mx-auto" /> : <X className="h-5 w-5 text-muted-foreground/40 mx-auto" /> : <span className="text-foreground">{feature.enterprise}</span>}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
};